export const SORRY = 'Przepraszamy!'
export const UNKNOW_ERROR_OCCURED = 'Wystąpił nieznany błąd'
